import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import request from 'utils/request';
import { EVENTS_CUSTOM_FIELDS_KEY } from './useEventCustomFieldDefinitions';

function createEventCustomField({
  schoolyearId,
  schoolId,
  data,
}: {
  schoolyearId: string;
  schoolId: string;
} & { data: CustomFieldDefinitionWithTargets }) {
  return request(
    `/schoolyears/${schoolyearId}/schools/${schoolId}/events-custom-fields`,
    {
      method: 'POST',
      body: data,
    },
  );
}

export const useCreateEventCustomFieldDefinition = ({
  schoolyearId,
  schoolId,
}: {
  schoolyearId: string;
  schoolId: string;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CustomFieldDefinitionWithTargets) =>
      createEventCustomField({ schoolyearId, schoolId, data }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [EVENTS_CUSTOM_FIELDS_KEY, schoolyearId, schoolId],
      });
    },
  });
};
